import { React } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import componentStyles from "assets/theme/views/admin/static-page.js";
import LocationHeader from "components/Headers/LocationHeader";
import { labels } from "resources/resources";

const useStyles = makeStyles(componentStyles);

function UsefulLinks() {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Container maxWidth={false} classes={{ root: classes.containerRoot }}>
      <Box marginLeft="-30px">
        <LocationHeader section={intl.formatMessage(labels.Label_Menu_Help_UsefulLinks)} />
      </Box>
      <Grid container>
        <Grid item xs={12}>
          <Card className={classes.cardRoot}>
            <CardContent>
              <Grid item xs={12} md={12}>
                <Box classes={{ root: classes.pageTitle }}>
                  {intl.formatMessage(labels.Label_Menu_Help_UsefulLinks)}
                </Box>
                <div>{intl.formatMessage(labels.Label_No_Information_To_Present)}</div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(UsefulLinks);
